import { StyleSheet } from 'react-native';
import type { StylesMap } from 'types';
import Theme from 'Theme';

const styles: StylesMap = {
    languageButton: {
        height: 40,
        lineHeight: 40,
        width: '100%',
        textAlign: 'center'
    },
    languageButtonLabel: {
        fontSize: 15,
        color: Theme.secondaryButtonBorderColor,
        lineHeight: 40
    },
    selectedLabel: {
        color: '#00A0DE'
    }
};

export default StyleSheet.create(styles);
